/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

const json_replacer = (k: any, v: any) => v!==''? v: undefined ;

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export class MosaicClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:5000/MapVault";
    }

    getInstance(): AxiosInstance { return this.instance; }

    get(): Promise<Mosaic[]> {
        let url_ = this.baseUrl + "/api/Mosaic";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<Mosaic[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Mosaic.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Mosaic[]>(<any>null);
    }

    getFullList(): Promise<Mosaic[]> {
        let url_ = this.baseUrl + "/api/Mosaic/FullList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFullList(_response);
        });
    }

    protected processGetFullList(response: AxiosResponse): Promise<Mosaic[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Mosaic.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Mosaic[]>(<any>null);
    }

    details(id: string | null): Promise<ProductDetails> {
        let url_ = this.baseUrl + "/api/Mosaic/{id}/Details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
            url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<ProductDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDetails.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDetails>(<any>null);
    }

    thumbnail(gid: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Mosaic/{gid}/thumbnail";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
            url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "arraybuffer",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processThumbnail(_response);
        });
    }

    protected processThumbnail(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    attachment(gid: string, type: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Mosaic/{gid}/attachment?";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
            url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
        {
            // Note: this simplest case is implemented via the parameter config in the axios call
            //    url_ += "type=" + encodeURIComponent("" + type) + "&";
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "arraybuffer",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            params: {
                "type": type ,
            },
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAttachment(_response);
        });
    }

    protected processAttachment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    metadata(gid: string, filename: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Mosaic/{gid}/metadata?";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
            url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        if (filename !== undefined)
        {
            // Note: this simplest case is implemented via the parameter config in the axios call
            //    url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "arraybuffer",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            params: {
                "filename": filename ,
            },
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMetadata(_response);
        });
    }

    protected processMetadata(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class UserClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:5000/MapVault";
    }

    validate(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class Mosaic implements IMosaic {
    guid!: string;
    title!: string;
    minZoom?: number | undefined;
    maxZoom?: number | undefined;
    lastModified?: Date;
    extent!: Bounds;
    pubStatus!: PublicationStatus;
    format?: string | undefined;
    profile?: string | undefined;
    authorized?: boolean;
    yearsOfPublication?: string | undefined;
    publishers?: string[] | undefined;
    sheetCount?: number | undefined;
    extension?: string | undefined;

    constructor(data?: IMosaic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extent = new Bounds();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.minZoom = _data["minZoom"];
            this.maxZoom = _data["maxZoom"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.extent = _data["extent"] ? Bounds.fromJS(_data["extent"]) : new Bounds();
            this.pubStatus = _data["pubStatus"];
            this.format = _data["format"];
            this.profile = _data["profile"];
            this.authorized = _data["authorized"];
            this.yearsOfPublication = _data["yearsOfPublication"];
            if (Array.isArray(_data["publishers"])) {
                this.publishers = [] as any;
                for (let item of _data["publishers"])
                    this.publishers!.push(item);
            }
            this.sheetCount = _data["sheetCount"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): Mosaic {
        data = typeof data === 'object' ? data : {};
        let result = new Mosaic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["minZoom"] = this.minZoom;
        data["maxZoom"] = this.maxZoom;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["extent"] = this.extent ? this.extent.toJSON() : <any>undefined;
        data["pubStatus"] = this.pubStatus;
        data["format"] = this.format;
        data["profile"] = this.profile;
        data["authorized"] = this.authorized;
        data["yearsOfPublication"] = this.yearsOfPublication;
        if (Array.isArray(this.publishers)) {
            data["publishers"] = [];
            for (let item of this.publishers)
                data["publishers"].push(item);
        }
        data["sheetCount"] = this.sheetCount;
        data["extension"] = this.extension;
        return data; 
    }
}

export interface IMosaic {
    guid: string;
    title: string;
    minZoom?: number | undefined;
    maxZoom?: number | undefined;
    lastModified?: Date;
    extent: Bounds;
    pubStatus: PublicationStatus;
    format?: string | undefined;
    profile?: string | undefined;
    authorized?: boolean;
    yearsOfPublication?: string | undefined;
    publishers?: string[] | undefined;
    sheetCount?: number | undefined;
    extension?: string | undefined;
}

export class Bounds implements IBounds {
    xMin!: number;
    xMax!: number;
    yMin!: number;
    yMax!: number;
    xc?: number;
    yc?: number;

    constructor(data?: IBounds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.xMin = _data["xMin"];
            this.xMax = _data["xMax"];
            this.yMin = _data["yMin"];
            this.yMax = _data["yMax"];
            this.xc = _data["xc"];
            this.yc = _data["yc"];
        }
    }

    static fromJS(data: any): Bounds {
        data = typeof data === 'object' ? data : {};
        let result = new Bounds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["xMin"] = this.xMin;
        data["xMax"] = this.xMax;
        data["yMin"] = this.yMin;
        data["yMax"] = this.yMax;
        data["xc"] = this.xc;
        data["yc"] = this.yc;
        return data; 
    }
}

export interface IBounds {
    xMin: number;
    xMax: number;
    yMin: number;
    yMax: number;
    xc?: number;
    yc?: number;
}

export enum PublicationStatus {
    Planned = 0,
    Processing = 1,
    Published = 2,
    Retired = 3,
}

export class ProductDetails implements IProductDetails {
    guid!: string;
    title!: string;
    extent?: Bounds | undefined;
    yearsOfPublication?: string | undefined;
    publishers?: string[] | undefined;
    scale?: string | undefined;
    languages?: string[] | undefined;
    sheetCount?: number;
    isCountApproximate?: boolean;
    description?: string | undefined;
    revisionDate?: string | undefined;
    themeKeywords?: string[] | undefined;
    placeKeywords?: string[] | undefined;
    lineage?: string | undefined;
    topicCategory?: string | undefined;
    hasAttachment?: boolean[] | undefined;
    authorized?: boolean;

    constructor(data?: IProductDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.extent = _data["extent"] ? Bounds.fromJS(_data["extent"]) : <any>undefined;
            this.yearsOfPublication = _data["yearsOfPublication"];
            if (Array.isArray(_data["publishers"])) {
                this.publishers = [] as any;
                for (let item of _data["publishers"])
                    this.publishers!.push(item);
            }
            this.scale = _data["scale"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.sheetCount = _data["sheetCount"];
            this.isCountApproximate = _data["isCountApproximate"];
            this.description = _data["description"];
            this.revisionDate = _data["revisionDate"];
            if (Array.isArray(_data["themeKeywords"])) {
                this.themeKeywords = [] as any;
                for (let item of _data["themeKeywords"])
                    this.themeKeywords!.push(item);
            }
            if (Array.isArray(_data["placeKeywords"])) {
                this.placeKeywords = [] as any;
                for (let item of _data["placeKeywords"])
                    this.placeKeywords!.push(item);
            }
            this.lineage = _data["lineage"];
            this.topicCategory = _data["topicCategory"];
            if (Array.isArray(_data["hasAttachment"])) {
                this.hasAttachment = [] as any;
                for (let item of _data["hasAttachment"])
                    this.hasAttachment!.push(item);
            }
            this.authorized = _data["authorized"];
        }
    }

    static fromJS(data: any): ProductDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["extent"] = this.extent ? this.extent.toJSON() : <any>undefined;
        data["yearsOfPublication"] = this.yearsOfPublication;
        if (Array.isArray(this.publishers)) {
            data["publishers"] = [];
            for (let item of this.publishers)
                data["publishers"].push(item);
        }
        data["scale"] = this.scale;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["sheetCount"] = this.sheetCount;
        data["isCountApproximate"] = this.isCountApproximate;
        data["description"] = this.description;
        data["revisionDate"] = this.revisionDate;
        if (Array.isArray(this.themeKeywords)) {
            data["themeKeywords"] = [];
            for (let item of this.themeKeywords)
                data["themeKeywords"].push(item);
        }
        if (Array.isArray(this.placeKeywords)) {
            data["placeKeywords"] = [];
            for (let item of this.placeKeywords)
                data["placeKeywords"].push(item);
        }
        data["lineage"] = this.lineage;
        data["topicCategory"] = this.topicCategory;
        if (Array.isArray(this.hasAttachment)) {
            data["hasAttachment"] = [];
            for (let item of this.hasAttachment)
                data["hasAttachment"].push(item);
        }
        data["authorized"] = this.authorized;
        return data; 
    }
}

export interface IProductDetails {
    guid: string;
    title: string;
    extent?: Bounds | undefined;
    yearsOfPublication?: string | undefined;
    publishers?: string[] | undefined;
    scale?: string | undefined;
    languages?: string[] | undefined;
    sheetCount?: number;
    isCountApproximate?: boolean;
    description?: string | undefined;
    revisionDate?: string | undefined;
    themeKeywords?: string[] | undefined;
    placeKeywords?: string[] | undefined;
    lineage?: string | undefined;
    topicCategory?: string | undefined;
    hasAttachment?: boolean[] | undefined;
    authorized?: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}